// Arquivo: src/components/DevAlert.tsx (crie este arquivo)

import React, { useState, useEffect } from 'react';
import { useTheme } from '@mui/material/styles';
import Alert from '@mui/material/Alert';
import Collapse from '@mui/material/Collapse';

function DevAlert() {
  const theme = useTheme();
  const isDevelopment = process.env.NODE_ENV === 'development';
  const [open, setOpen] = useState(true);
  
  // Auto-fechar após 5 segundos
  useEffect(() => {
    if (isDevelopment) {
      const timer = setTimeout(() => setOpen(false), 5000);
      return () => clearTimeout(timer);
    }
  }, [isDevelopment]);
  
  if (!isDevelopment) return null;
  
  return (
    <Collapse in={open}>
      <Alert 
        severity="info" 
        onClose={() => setOpen(false)}
        sx={{ 
          bgcolor: theme.palette.devHighlight?.main || '#ff9800', 
          color: 'white',
          '& .MuiAlert-icon': { color: 'white' } 
        }}
      >
        Ambiente de Desenvolvimento - API: {process.env.REACT_APP_DEV_API_URL}
      </Alert>
    </Collapse>
  );
}

export default DevAlert;